import React from 'react';
import 'react-chat-widget/lib/styles.css';
import ShareTabs from "./shareTabs";
import {Redirect, Route, Switch, useRouteMatch} from "react-router-dom";

const ParentShareTabs = props => {
    let {url} = useRouteMatch();

    return (
        <div>
            <Switch>
                <Redirect exact from={props.parent.redirectMatch} to={`${url}${props.parent.redirectSlash}`} />

                {Object.keys(props.parent.routes).map((key, idx) => {
                    const route = props.parent.routes[key];
                    return (
                        <Route key={idx} path={`${url}`}>
                            <ShareTabs
                                {...props}
                                parent={route}
                                childComponent={props.parent.component}
                            />
                        </Route>
                    )
                })}
            </Switch>
        </div>
    );
};

export default ParentShareTabs
